export function isOurDomain(url: string): boolean {
  try {
    const urlObj = new URL(url, window.location.origin);
    const hostname = urlObj.hostname;

    // Check for our known domains using regex
    // Matches: localhost, 127.0.0.1, arthelper.ai, *.arthelper.ai, *.artstorefrontsstaging.info
    const domainPattern = /^(localhost|127\.0\.0\.1|(.*\.)?arthelper\.ai|(.*\.)?artstorefrontsstaging\.info)$/;

    return domainPattern.test(hostname);
  } catch {
    return false;
  }
}
